import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class BasicInfoService {


    static async getBankAccounts(doc) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/info/getBankAccounts/${doc}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    

    static async getBankAccountsWithLabel(doc) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/info/getBankAccountsWithLabel/${doc}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async getBasicInfo(doc) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/info/get-info/${doc}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async addBankAccount(payload={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/info/addBankAccount`, payload);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async addPrincipalBankAccount(payload={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/info/addPrincipalBankAccount`, payload);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async updateBankAccount(doc, payload={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.put(`${variablesGlobales.urlServiceBackend}/api/v1/info/updateBankAccount/${doc}`, payload);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async changePrincipalBankAccount(payload={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/info/changePrincipalBankAccount`, payload);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async deleteBankAccount(doc, id) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.delete(`${variablesGlobales.urlServiceBackend}/api/v1/info/deleteAccount/${doc}/${id}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    //Valida si el usuario tiene un credito vigente
    static async hasCreditActive(doc) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/credits/hasActive/${doc}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData?.info,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

}